import { Solutions } from '../../app/models/environment-configuration';

export const AUDITOR_COPILOT_COMMON_ENV = {
  solution: Solutions.AUDITOR_COPILOT,
};
